import { FeatureOverrides } from './types';
import { resolveEnvironmentOverrides } from './evaluation';

export const DEFAULT_FEATURE_OVERRIDES: FeatureOverrides = {};

export function getDefaultFeatureOverrides(): FeatureOverrides {
  return {
    ...DEFAULT_FEATURE_OVERRIDES,
    ...resolveEnvironmentOverrides(),
  };
}
